"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toType = void 0;
const toType = (type) => (value) => {
    switch (type) {
        case 'integer':
        case 'numeric':
            return Number(value);
        case 'boolean':
            return Boolean(value);
        case 'date':
            return new Date(value);
        default:
            return value;
    }
};
exports.toType = toType;
//# sourceMappingURL=utils.js.map